<mat-button-toggle-group class="content-switcher small max-width"
                         *ngIf="authService.aliasSalespoints.length" [(ngModel)]="showAliasSalespointSelection"
                         [ngModelOptions]="{standalone: true}" (ngModelChange)="suggestSalespoint()">
  <mat-button-toggle [value]="false">{{'general.api_user_menu_salespoints_regular' | translate}}</mat-button-toggle>
  <mat-button-toggle [value]="true">{{'general.api_user_menu_salespoints_alias' | translate}}</mat-button-toggle>
</mat-button-toggle-group>
<mat-form-field appearance="outline" class="max-width top-spacer" *ngIf="!showAliasSalespointSelection && authService.salespoints.length > 1">
  <mat-label>{{ 'general.api_user_menu_select_salespoint' | translate }}</mat-label>
  <mat-select [(ngModel)]="currentSalespointId" [ngModelOptions]="{standalone: true}" (ngModelChange)="suggestRole()">
    <mat-select-trigger>{{getSalespointLabelById(currentSalespointId, authService.salespoints)}}</mat-select-trigger>
    <mat-option>
      <app-select-search [values]="authService.primarySalespoints" [filterBy]="['salespointName', 'legalPerson.companyName']" (filteredValues)="filteredPrimarySalespoints.next($event.slice())"></app-select-search>
    </mat-option>
    <mat-option *ngFor="let salespoint of filteredPrimarySalespoints | async" [value]="salespoint.salespointId">
      {{getSalespointLabel(salespoint)}}
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field appearance="outline" class="max-width top-spacer" *ngIf="showAliasSalespointSelection && authService.aliasSalespoints.length">
  <mat-label>{{ 'general.api_user_menu_select_other_salespoint' | translate }}</mat-label>
  <mat-select [(ngModel)]="currentSalespointId" [ngModelOptions]="{standalone: true}" (ngModelChange)="suggestRole()">
    <mat-select-trigger>{{getSalespointLabelById(currentSalespointId, authService.aliasSalespoints)}}</mat-select-trigger>
    <mat-option>
      <app-select-search [values]="authService.aliasSalespoints" [filterBy]="['salespointName', 'legalPerson.companyName']" (filteredValues)="filteredAliasSalespoints.next($event.slice())"></app-select-search>
    </mat-option>
    <mat-option *ngFor="let salespoint of filteredAliasSalespoints | async" [value]="salespoint.salespointId">
      {{getSalespointLabel(salespoint)}}
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field appearance="outline" class="max-width top-spacer" *ngIf="permissionRoles && permissionRoles.length > 1">
  <mat-label>{{ 'general.api_user_menu_select_role' | translate }}</mat-label>
  <mat-select [(ngModel)]="currentRoleId" [ngModelOptions]="{standalone: true}" (ngModelChange)="changes = true">
    <mat-select-trigger>{{getRoleLabelById(currentRoleId)}}</mat-select-trigger>
    <mat-option>
      <app-select-search [values]="permissionRoles" [filterBy]="['role.name']" (filteredValues)="permissionRolesFiltered.next($event.slice())"></app-select-search>
    </mat-option>
    <mat-option *ngFor="let permissionRole of permissionRolesFiltered | async" [value]="permissionRole.role.id">
      {{ permissionRole.role.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
